import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import { useToast } from '../context/ToastContext';
import './LoginPage.css'; // Reusing some login styles for consistency

const VerifyEmail: React.FC = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const navigate = useNavigate();
    const { showToast } = useToast();
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
    const [message, setMessage] = useState('Verificando tu correo electrónico...');
    const initialized = React.useRef(false);

    useEffect(() => {
        if (initialized.current) return;
        initialized.current = true;

        const verifyToken = async () => {
            if (!token) {
                setStatus('error');
                setMessage('Token de verificación no encontrado.');
                return;
            }

            try {
                console.log('[DEBUG] Starting email verification for token:', token.substring(0, 8) + '...');
                await authService.verifyEmail(token);
                setStatus('success');
                setMessage('¡Tu correo electrónico ha sido verificado con éxito!');
                showToast('Cuenta verificada con éxito. Ya puedes iniciar sesión.', 'success');
            } catch (error: any) {
                console.error('[DEBUG] Verification error:', error);
                // If it's already verified, we might have hit a race condition but it's actually fine
                // However, the backend should handle this. 
                setStatus('error');
                setMessage(error.response?.data?.error || 'Hubo un error al verificar tu correo.');
            }
        };

        verifyToken();
    }, [token, showToast]);

    return (
        <div className="login-container">
            <div className="login-card" style={{ textAlign: 'center', padding: '3rem' }}>
                <div className="login-header">
                    <h1 style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>Verificación de Correo</h1>
                </div>

                <div className="verification-content">
                    {status === 'loading' && (
                        <div className="spinner-container">
                            <div className="spinner"></div>
                            <p style={{ marginTop: '1rem', color: 'var(--text-secondary)' }}>{message}</p>
                        </div>
                    )}

                    {status === 'success' && (
                        <div className="success-message">
                            <i className="fas fa-check-circle" style={{ fontSize: '4rem', color: '#10b981', marginBottom: '1.5rem', display: 'block' }}></i>
                            <p style={{ fontSize: '1.2rem', marginBottom: '2rem' }}>{message}</p>
                            <button
                                className="btn btn-primary"
                                style={{ width: '100%' }}
                                onClick={() => navigate('/login')}
                            >
                                Ir al Inicio de Sesión
                            </button>
                        </div>
                    )}

                    {status === 'error' && (
                        <div className="error-message">
                            <i className="fas fa-exclamation-circle" style={{ fontSize: '4rem', color: '#ef4444', marginBottom: '1.5rem', display: 'block' }}></i>
                            <p style={{ fontSize: '1.2rem', marginBottom: '2rem' }}>{message}</p>
                            <button
                                className="btn btn-secondary"
                                style={{ width: '100%' }}
                                onClick={() => navigate('/register')}
                            >
                                Volver al Registro
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VerifyEmail;
